class Nivel {
  constructor(dados) {
    this.id = dados ? dados.id : null;
    this.nome = dados ? dados.nome : null;
  }

  static validations(required, maxLength) {
    return {
      nome: { required, maxLength: maxLength(100) }
    };
  }

  static validationMessages() {
    return {
      nome: {
        required: "Nome é obrigatório",
        maxLength: "Nome só aceita no máximo 100 caracteres"
      }
    };
  }
}
export default Nivel;
